import { useEffect, useState } from 'react'
import { X } from 'lucide-react'

export default function RoomScanRenameModal({ scan, onCancel, onSubmit, busy }) {
  const [name, setName] = useState(scan?.name || '')

  useEffect(() => {
    setName(scan?.name || '')
  }, [scan])

  if (!scan) return null

  const submit = (e) => {
    e?.preventDefault?.()
    const trimmed = name.trim()
    if (!trimmed || trimmed === scan.name) {
      onCancel?.()
      return
    }
    onSubmit?.({ name: trimmed })
  }

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <form
        className="modal"
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
      >
        <div className="modal__header">
          <h2 className="modal__title">Rename scan</h2>
          <button type="button" className="icon-btn" aria-label="Close" onClick={onCancel}>
            <X size={16} />
          </button>
        </div>
        <div className="modal__form">
          <label className="col" style={{ gap: 6 }}>
            <span className="muted" style={{ fontSize: 12 }}>Name</span>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
              maxLength={120}
            />
          </label>
        </div>
        <div className="modal__actions">
          <button type="button" className="btn" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button type="submit" className="btn btn--primary" disabled={busy}>
            {busy ? 'Saving…' : 'Save'}
          </button>
        </div>
      </form>
    </div>
  )
}
